import { Stack, Pagination } from "@mui/material"
import Div from "../../../components/Div";
import Input from "../../../components/Input";
import { useState, useEffect, useCallback } from "react";
import PageTitle from "../../../components/PageTitle";
import FormButton from "../../../components/FormButton";
import {
    getResellerList,
    //  getFollowUpComments, updateSegmentsHttp, updateZoneHttp,
    // createRenewalInvoice, createRenewalProposal 
} from "../../../http/renewalHttp/RenewalHttp";
import FollowupHistoryModal from "../../../components/Renewal/FollowupHistoryModal";
import AddCommentModal from "../../../components/Renewal/AddCommentModal";
// import Select from "../../../components/Select";
import RenewalResellerNotificationModal from "../../../components/Renewal/RenewalResellerNotificationModal";
// import { segments, zones } from '../../../util/enum';
import { CiImport } from "react-icons/ci";
// import { getSessionUser } from "../../../util/validation";

export default function RenewalResellerList() {

    const [customerList, setCustomerList] = useState([]);
    // const [isAscending, setIsAscending] = useState(true);
    const [initialCustomerList, setInitialCustomerList] = useState([])
    const [followupHistory, setFollowupHistory] = useState(false);
    // const [sendNotification, setSendNotification] = useState(false);
    const [addComment, setAddComment] = useState(false);
    const [resellerCustomer, setResellerCustomer] = useState(false)

    const getCurrentYearMonth = () => {
        const date = new Date();
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
      };

    const [month, setMonth] = useState(getCurrentYearMonth);

    const currentMonth = new Date().toLocaleString('en-US', { month: 'long' });
    const [formattedMonth, setFormattedMonth] = useState(currentMonth);

    const [search, setSearch] = useState('')
    // const [sortColumn, setSortColumn] = useState(null);
    // const [sortOrder, setSortOrder] = useState("asc");


    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 10;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const currentItems = customerList.slice(indexOfFirstItem, indexOfLastItem);


    // Calculate total pages
    const totalPages = Math.ceil(customerList.length / itemsPerPage);

    // Change page
    const paginate = (event, value) => {
        setCurrentPage(value);
    };

    // const zone = zones.zone.map((zone) =>
    //     zone.id !== currentItems ?
    //         <option key={zone.id}
    //             name={zone.id}
    //             value={zone.id}>
    //             {zone.value}</option>
    //         : null);

    // const state = segments.segment.map((state) =>
    //     state.id !== currentItems ?
    //         <option key={state.id}
    //             name={state.id}
    //             value={state.id}>
    //             {state.value}</option>
    //         : null)


    const getMonthlyResellerRenewal = useCallback(async (date) => {
        const response = await getResellerList(date)
        if (response) {

    setCustomerList(response.domain);
    setInitialCustomerList(response.domain);
            // setInitialCustomerList(response.customer)
        } else {
            setCustomerList([])
            setInitialCustomerList([])
        }
    }, [])

    useEffect(() => {
        const date = new Date()
        const currentYear = date.getFullYear(); // Get current year (YYYY)
        let currentMonth = (date.getMonth() + 1).toString(); // Get current month (1-12)

        // Ensure month is in MM format by adding a leading zero if needed
        if (currentMonth.length < 2) {
            currentMonth = '0' + currentMonth;
        }

        const formattedDate = `${currentYear}-${currentMonth}`; // Format as YYYY-MM

        getMonthlyResellerRenewal(formattedDate)
    }, [getMonthlyResellerRenewal])




    // async function handleFollowUp(renewal_id) {
    //     const followUpCommentResponse = await getFollowUpComments(renewal_id)
    //     // if (followUpCommentResponse){
    //     const followComments = {
    //         'renewal_id': renewal_id,
    //         'followupComments': followUpCommentResponse ? followUpCommentResponse.followup_comment : []
    //     }
    //     setFollowupHistory(followComments)

    // }

    function handleExport() {

        if (currentItems) {
            const array = [Object.keys(currentItems[0])].concat(customerList);

            const csv = array.map(row => Object.values(row).toString()).join('\n');
            // console.log(csv)
            const blob = new Blob([csv], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.setAttribute('href', url);
            a.setAttribute('download', 'data.csv');
            a.click();
        }
        else {
            return null;
        }
    }

    // const [selectedZone, setSelectedZone] = useState({});
    // const [selectedSegment, setSelectedSegment] = useState({});

    // const handleZoneChange = (renewal_id, value) => {
    //     setSelectedZone(prev => ({ ...prev, [renewal_id]: value }));
    // };

    // const handleSegmentChange = (renewal_id, value) => {
    //     setSelectedSegment(prev => ({ ...prev, [renewal_id]: value }));
    // };

    // const handleUpdateZone = async (renewal_id) => {
    //     if (selectedZone[renewal_id]) {
    //         const zoneResponse = await updateZoneHttp(renewal_id, selectedZone[renewal_id]);
    //         if (!zoneResponse) {
    //             alert('Failed to Update Zone. Please try refreshing the page');
    //         }
    //     }
    // };

    // const handleUpdateSegment = async (renewal_id) => {
    //     if (selectedSegment[renewal_id]) {
    //         const segmentResponse = await updateSegmentsHttp(renewal_id, selectedSegment[renewal_id])
    //         if (!segmentResponse) {
    //             alert('Failed to Update Segment. Please try refreshing the page');
    //         }
    //     }
    // };

    function handleResellerClick(reseller_email, reseller_company, assigned_to){
        setResellerCustomer({'reseller_email' : reseller_email ? reseller_email: reseller_company,
            'tag': reseller_email ? 'email' : 'company' ,
            'month': month,
            'reseller_company': reseller_company,
            'assigned_to' : assigned_to
        })

    }

    // function handleSendNotification(domain_name, renewal_id, subscription_id, renewal_date) {
    //     const notifyData = {
    //         'domain_name': domain_name,
    //         'renewal_id': renewal_id,
    //         'subscription_id': subscription_id,
    //         'renewal_date': renewal_date
    //     }
    //     setSendNotification(notifyData)
    // }

    // function handleAddComment(renewal_id) {

    //     setAddComment(true);

    // }

    function handleMonthChange(event) {
        const month_item = event.target.value
        console.log(month_item)
        setInitialCustomerList([])
        setCustomerList([])
        getMonthlyResellerRenewal(month_item)
        let [year, month] = month_item.split("-").map(Number);

        // Adjust month (subtracting 1 to get the previous month)
        let prevMonthDate = new Date(year, month - 1); // `month - 2` because JS months are 0-based
        setFormattedMonth(prevMonthDate.toLocaleString('en-US', { month: 'long' }));
        setMonth(month_item)
        setCurrentPage(1)

    }

    const handleSort = (column) => {

    };

    function handleSearchCustomer(event) {

        const search_item = event.target.value;
        
        console.log(search_item)
        const filteredList = initialCustomerList.filter((customer) => {
        
            if (customer?.company_name) {
    const name = customer.company_name.trim().toLowerCase();
    const term = search_item.trim().toLowerCase();
    const match = name.includes(term);
    return match;
  }else{return false}
        });
       setCustomerList([])
        setCustomerList(filteredList);
        setSearch(search_item)
        setCurrentPage(1)
    }

    return (
        <>
            {resellerCustomer ? <RenewalResellerNotificationModal notify={resellerCustomer} 
            show={true.toString()} open handleClicked={setResellerCustomer} /> : null}
            {addComment ? <AddCommentModal comments={addComment} show={true.toString()} open handleClicked={setAddComment} /> : null}
            {followupHistory ? <FollowupHistoryModal history={followupHistory} show={true.toString()} open handleClicked={setFollowupHistory} /> : null}
            <PageTitle title={`Monthly Renewal Data for Reseller ${formattedMonth}`} />
            <Div className="col-md-12">
                <Div className="page-header-toolbar">

                    <Div className="btn-group toolbar-item" role="group" >

                        <Input type='month' name='month' id='month' style={{ marginLeft: '50px', opacity: '0.8' }} value={month}
                            onChange={handleMonthChange}
                        />

                    </Div>

                    <Div className="btn-group toolbar-item" role="group" >

                        <Input type='text' name='text' id='text' style={{ marginLeft: '50px', opacity: '0.8' }} value={search}
                            onChange={handleSearchCustomer}
                        />

                    </Div>


                    <FormButton
                        className="btn btn-primary ml-2"
                        style={{ float: "right" }}
                        onClick={handleExport}
                        title="Export Reseller Data"
                    >
                        <CiImport size={15} />
                    </FormButton>

                    <Div className="filter-wrapper">
                    </Div>
                </Div>
            </Div>

            <Div className="col-md-12 margin_top" style={{ opacity: '0.9' }} >
                {customerList.length > 0 ? <table className="table" border="1">
                    <thead>
                        <tr>
                            <th>Company Name</th>
                            <th className="sortable-header"
                                onClick={() => handleSort("renewal_date")}
                            >Email
                            </th>
                            <th>Assigned To</th>
                             {/* <th>Add Comment</th>
                            <th>Follow up History</th> */}
                            <th>Count</th>
                            {/*<th>Follow Up Comments</th> */}

                        </tr>
                    </thead>
                    <tbody id="tableBody">
                        {currentItems.map((customer) =>

                            <tr>
                                <td><FormButton
                                type='button'
                                className="btn btn-link"
                                onClick={() => handleResellerClick(customer.email, customer.company_name, customer.assigned_to)}
                                >
                                    {customer.company_name}
                                    </FormButton>
                                    </td>
                                <td> 
                                {customer.email}
                                    </td>
                                    <td>
                                        {customer.assigned_to}
                                    </td>
                                {/* <td>
                                    <FormButton
                                        type='button'
                                        className="btn btn-primary submit-btn btn-block"
                                        onClick={() => handleAddComment(customer.renewal_id)}
                                    >Add Comments</FormButton>
                                </td>

                                <td>
                                    <FormButton
                                        type='button'
                                        className="btn btn-primary submit-btn btn-block"
                                        onClick={() => handleFollowUp(customer.renewal_id)}
                                    >Follow up History</FormButton>
                                </td> */}
                                {/* <td>{customer.followup_comments}</td> */}
                                <td>{customer.count}</td>
 
                                
                            </tr>
                        )

                        }
                    </tbody>
                </table> :
                    <>
                        <p style={{ marginTop: '30px' }}>No Domain Present or Could not fetch Domains</p>
                    </>}

                {currentItems.length > 0 ?
                    <Stack spacing={2}>
                        <Pagination count={totalPages} color="primary" page={currentPage} onChange={paginate}>

                        </Pagination>

                    </Stack> : null
                }
            </Div>

        </>
    )
}